import { apiStatementStatuses } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'statement-statuses';

const config = [
  { actionType: 'getAll', apiPath: apiStatementStatuses, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiStatementStatuses}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
